<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_reports'] == 1">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <div class="">
                <div class="row my-1">
                  <b-form-group class="col-md-4 px-1" label="Date From">
                    <input
                      v-model="datefrom"
                      type="date"
                      required
                      class="form-control"
                    />
                  </b-form-group>
                  <b-form-group class="col-md-4 px-1" label="Date To">
                    <input
                      v-model="dateto"
                      type="date"
                      required
                      class="form-control"
                    />
                  </b-form-group>
                  <div class="col-md-3 mt-md-4 mt-23 p-lg-0">
                    <b-button variant="primary" @click="FilterData()"
                      ><i class="mdi mdi-account-search"></i> Filter</b-button
                    >
                  </div>
                </div>
              </div>
              <div class="mt-4">
                <small><b>Export to </b></small>
                <div class="btn-group">
                  <b-button
                    :disabled="payments.length <= 0"
                    type="button"
                    class="btn btn-sm btn-success"
                    @click="printPDF"
                    >PDF <i class="mdi mdi-file-pdf"></i
                  ></b-button>
                  <export-excel
                    type="button"
                    class="btn btn-sm btn-info"
                    :data="payments"
                    :name="this.title"
                  >
                    Excel <i class="mdi mdi-file-excel"></i
                  ></export-excel>
                </div>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive" id="print-section">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Selected Yet</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(student)="data">
                    <small
                      ><b>{{ data.item.student.student_id }}</b></small
                    ><br />
                    {{ data.item.student.first_name }}
                    {{ data.item.student.last_name }}
                  </template>
                  <template #cell(mode)="data">
                    {{ data.item.mode.name }}
                  </template>
                  <template #cell(paydate)="data">
                    {{ data.item.payment.pay_date }}
                  </template>
                  <template #cell(receipt_id)="data">
                    {{ data.item.payment.receipt_id }}
                  </template>
                  <template #cell(total)="data">
                    {{ commas(data.item.payment.total) }}
                  </template>
                </b-table>
              </div>

              <div class="row">
                <div class="col">
                  <b>Total Amount Paid : {{ commas(totalpaid) }}</b>
                </div>
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import axios from "axios";
import html2pdf from "html2pdf.js";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Fees Payments Ledger",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Fees Payments Ledger",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Fees Payments Ledger", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "student", label: "Student", visible: true },
        { key: "receipt_id", label: "Receipt Id", visible: true },
        { key: "total", label: "Amount Paid", visible: true },
        { key: "mode", label: "Payment Mode", visible: true },
        { key: "paydate", label: "Payment Date", visible: true },
      ],
      id: "",
      schoolclass: "",
      datefrom: new Date().toLocaleDateString("fr-CA"),
      dateto: new Date().toLocaleDateString("fr-CA"),
      payments: [],
    };
  },
  computed: {
    List() {
      return this.payments.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.payments.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.payments.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
    totalpaid() {
      var total = 0;
      this.payments.forEach((item) => {
        var item_total = item.payment.total;
        total = Number(total) + Number(item_total);
      });
      return total;
    },
  },
  mounted() {
    this.TotalRows = this.payments.length;
    this.isBusy = false;
  },
  methods: {
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    FilterData() {
      let formData = new FormData();
      formData.append("datefrom", this.datefrom);
      formData.append("dateto", this.dateto);
      let url = "/feespaymentsledger";
      axios.post(url, formData).then((response) => {
        this.payments = response.data.payments;
      });
    },
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    printPDF() {
      const element = document.getElementById("print-section");
      const options = {
        filename:
          this.title + " : " + this.datefrom + " - " + this.dateto + ".pdf",
        image: { type: "png", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
      html2pdf()
        .from(element)
        .set(options)
        .save();
    },
  },
};
</script>
